import React from 'react'
import uniqid from 'uniqid'

import { Header } from '../..'
import { TopNavigationItem } from '../../TopNavigation/TopNavigation'
import twitterLogo from '../../../_images/logos/logo-white-twitter.png'
import './_susf-site-footer.scss'

export type SustainableFitchSiteFooterProps = {
  version?: string
  handlePreferencesClick: () => void
  navigation: TopNavigationItem[]
}

export const SustainableFitchSiteFooter = ({
  navigation
}: SustainableFitchSiteFooterProps) => {
  const currentYear = new Date().getFullYear()
  return (
    <footer className="footer">
      <section className="footer__links">
        <div className="wrapper--1">
          <div className="column__five">
            {navigation.map(({ label, menus }) => (
              <div className="column" key={uniqid()}>
                <Header level={4} className="heading--5">
                  {label}
                </Header>
                <ul>
                  {menus.map(
                    ({ label, relatedLinkHref, title, target, links = [] }) => (
                      <React.Fragment key={uniqid()}>
                        {links && links.length > 0 ? (
                          <>
                            <li>
                              <strong>{label || title}</strong>
                            </li>
                            {links
                              .filter((link) => 'relatedLinkHref' in link)
                              .map((link) => (
                                <li key={uniqid()}>
                                  <a
                                    href={link.relatedLinkHref}
                                    target={link.target || '_self'}
                                  >
                                    {link.label || link.title}
                                  </a>
                                </li>
                              ))}
                          </>
                        ) : (
                          <li>
                            <a
                              href={relatedLinkHref}
                              target={target || '_self'}
                            >
                              {label || title}
                            </a>
                          </li>
                        )}
                      </React.Fragment>
                    )
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="footer__legal">
        <div className="wrapper--1">
          <div className="column__two column__two--3-2">
            <div className="column column--1">
              <div>
                <div>
                  Copyright &copy; {currentYear} Fitch Group, Inc. and its
                  subsidiaries.
                  <span style={{ paddingLeft: '0.4rem' }}>
                    <a
                      href="https://www.fitch.group/policies"
                      rel="noreferrer"
                      className="link--underline"
                      target="_blank"
                    >
                      Policies
                    </a>{' '}
                    |{' '}
                    <a
                      href="https://www.fitch.group/cookie-policy"
                      rel="noreferrer"
                      className="link--underline"
                      target="_blank"
                    >
                      <span>Manage cookies</span>
                    </a>{' '}
                  </span>
                </div>
              </div>
            </div>
            <div className="column column--2">
              <div>
                <div>
                  <ul>
                    <li>
                      <a href="https://twitter.com/Fitch_ESG" target="twitter">
                        <img
                          className="footer-icon"
                          src={twitterLogo}
                          alt="twitter-logo"
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/company/sustainable-fitch/about/"
                        target="linkedin"
                      >
                        <i className="fab fa-linkedin-in" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  )
}

export default SustainableFitchSiteFooter
